<template>
  <v-container>
    <v-card>
      <v-card-title>Carreras</v-card-title>
      <v-card-subtitle>Consulta</v-card-subtitle>
      <v-card-text style="height: 15px; position: relative; top: -30px">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              absolute
              top
              right
              fab
              v-bind="attrs"
              v-on="on"
              @click="nuevoItem"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Agregar Carrera</span>
        </v-tooltip>
      </v-card-text>
    </v-card>

    <v-divider />

    <v-card>
      <template>
        <v-tabs show-arrows fixed-tabs v-model="tabSelected">
          <v-tab @click="getItems('all')"> Vigentes </v-tab>
          <v-tab @click="getItems('inactive')"> No vigentes </v-tab>
        </v-tabs>
      </template>

      <v-divider />
      <v-card-text v-if="dataFound">
        <v-list>
          <v-list-item
            link
            v-for="item in items"
            :key="item.id"
            @click.stop="muestraItem(item.id)"
            >{{ item.nombre }} ({{ item.plan_estudios }})</v-list-item
          >
        </v-list>
      </v-card-text>
      <v-card-text v-else>
        <p class="text-center">
          No se encontraron carreras, por favor seleccione otra opción.
        </p></v-card-text
      >
    </v-card>

    <Carrera
      v-if="showItem"
      :open="showItem"
      :datos="item"
      :subdatos="subitems"
      @edit="editDialog"
      @exit="oculta"
      @materia="muestraMateria"
      @new="nuevaMateria"
    />

    <CarreraEdit
      :open="editDlg"
      :datos="item"
      @save="actualiza('patch')"
      @exit="cierraDialog"
      @delete="actualiza('delete')"
    />

    <Materia
      :open="showMateria"
      :materia="materia"
      :no-eliminar="newMateria"
      @save="actualizaMateria('patch')"
      @exit="ocultaMateria"
      @delete="actualizaMateria('delete')"
    />
  </v-container>
</template>

<script>
import api from "@/api";
import Carrera from "@/components/Carrera";
import CarreraEdit from "@/components/CarreraEdit";
import Materia from "@/components/Materia";

export default {
  name: "Carreras",

  components: { Carrera, CarreraEdit, Materia },

  data: () => ({
    editDlg: false,
    item: {
      id: "",
      nombre: "",
      plan_estudios: "",
      activo: "",
    },
    subitems: null,
    items: null,
    dataFound: false,
    newItem: false,
    showItem: false,
    tabSelected: 0,
    materia: {
      id: "",
      nombre: "",
      academia: "",
      semestre: "",
      orden: "",
      horas: "",
    },
    newMateria: false,
    showMateria: false,
  }),

  methods: {
    async actualiza(action) {
      let data = {
        table: "carreras",
        scope: "ind",
        data: this.item,
      };
      if (this.newItem) {
        data = {
          ...data,
          action: "insert",
        };
      } else {
        if (this.item.id + "." != ".") {
          data = {
            ...data,
            action: action,
          };
        }
      }
      if (this.newItem || this.item.id + "." != ".") {
        try {
          const response = await api.send(data);
          if (action == "delete" || this.newItem) {
            this.getItems("all");
          }
          this.editDlg = false;
          this.newItem = false;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async actualizaMateria(action) {
      let data = {
        table: "plan_estudios",
        scope: "ind",
        data: this.materia,
      };
      if (this.newMateria) {
        data = {
          ...data,
          action: "insert",
        };
      } else {
        if (this.materia.id + "." != ".") {
          data = {
            ...data,
            action: action,
          };
        }
      }
      if (this.newMateria || this.materia.id + "." != ".") {
        try {
          const response = await api.send(data);
          this.showMateria = false;
          this.newMateria = false;
          // this.item = JSON.parse(JSON.stringify(this.itemId(id)));
          await this.getSubItems("carrera_id = " + this.item.id);
          // this.showItem = true;

          // this.getItems("all");
          // this.editDlg = false;
          // if (action == "delete") {
          //   this.getItems("all");
          // }
        } catch (error) {
          console.log(error);
        }
      }
    },

    cierraDialog() {
      this.editDlg = false;
    },

    editDialog() {
      this.editDlg = true;
    },

    async getItems(scope) {
      const response = await api.send({
        table: "carreras",
        action: "get",
        scope: scope,
        sort: "nombre, plan_estudios",
      });
      if (response.status == 200) {
        this.items = response.data;
        this.showItem = false;
        this.newItem = false;
        this.item = JSON.parse('{"id":"","nombre":"","plan_estudios":""}');
        if (this.items == null) {
          this.dataFound = false;
        } else this.dataFound = true;
      } else this.dataFound = false;
    },

    async getSubItems(scope) {
      const response = await api.send({
        table: "plan_estudios",
        action: "get",
        scope: scope,
        sort: "semestre, orden",
      });
      if (response.status == 200) {
        this.subitems = response.data;
      }
    },

    itemId(id) {
      if (this.items) {
        let items = this.items;
        for (let key in items) {
          if (items[key].id == id) {
            return items[key];
          }
        }
      }
      return null;
    },

    materiaId(id) {
      if (this.subitems) {
        let items = this.subitems;
        for (let key in items) {
          if (items[key].id == id) {
            return items[key];
          }
        }
      }
      return null;
    },

    async muestraItem(id) {
      this.item = JSON.parse(JSON.stringify(this.itemId(id)));
      await this.getSubItems("carrera_id = " + this.item.id);
      this.showItem = true;
    },

    muestraMateria(id) {
      this.showMateria = true;
      this.materia = JSON.parse(JSON.stringify(this.materiaId(id)));
    },

    async nuevaMateria() {
      let response = await api.send({
        table: "plan_estudios",
        action: "max",
        fields: "orden",
        scope: "carrera_id = " + this.item.id,
      });
      if (response.status == 200) {
        this.materia = JSON.parse(
          '{"id":"","carrera_id":"' +
            this.item.id +
            '","nombre":"","academia":"","semestre":"","orden":"' +
            (parseInt(response.data.maxorden) + 1) +
            '","horas":""}'
        );
      } else {
        this.materia = JSON.parse(
          '{"id":"","carrera_id":"' +
            this.item.id +
            '","nombre":"","academia":"","semestre":"","orden":"","horas":""}'
        );
      }
      this.newMateria = true;
      this.showMateria = true;
    },

    nuevoItem() {
      this.newItem = true;
      this.editDlg = true;
      this.item = JSON.parse(
        '{"id":"","nombre":"","plan_estudios":"","activo":"1"}'
      );
    },

    oculta() {
      this.getItems("all");
      this.showItem = false;
      this.newItem = false;
      this.item = JSON.parse(
        '{"id":"","nombre":"","academia":"","semestre":"","orden":"","horas":""}'
      );
    },

    ocultaMateria() {
      this.showMateria = false;
      this.newMateria = false;
      this.materia = JSON.parse(
        '{"id":"","nombre":"","academia":"","semestre":"","orden":"","horas":""}'
      );
    },
    semestreNo(no) {
      if (this.items) {
        let items = this.items;
        let list = [];
        let result = Object.keys(items).map(function (key) {
          if (items[key].semestre == no) list.push(items[key]);
          return items[key].semestre == no;
        });
        return list;
      } else return null;
    },
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Carreras");
    this.getItems("all");
  },
};
</script>